import { getMappedLocationList, getMappedPatientList } from "../../api/list";
import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UpdateLocationMappingAPI } from "../../api/update";
import { MappedLocationDeleteAPI } from "../../api/delete";

// State interface definition
interface MappedDataListState {
  MappedLocationList: any[];
  MappedPatientList: any[];
  isLoading: boolean;
  error: string | null;
}

// Initial state setup
const initialState: MappedDataListState = {
  MappedLocationList: [],
  MappedPatientList: [],
  isLoading: false,
  error: null,
};

// Async action to fetch error notes list
export const FetchMappedLocationList = createAsyncThunk(
  "MappedDataList/fetchMappedLocationList",
  async (params: any, { dispatch, getState }) => {
    try {
      const res: any = await getMappedLocationList(params);
      const state: any = getState();
      const previousMappedLocationList = state.MappedDataList?.MappedLocationList || []; // Extract the array correctly
      if ([1, undefined].includes(res?.result?.page)) {
        dispatch(setMappedLocationData(res?.result?.data || []));
      } else {


        dispatch(setMappedLocationData([
          ...previousMappedLocationList, // Keep existing data
          ...(res?.result?.data || []), // Append new data
        ]));
      }
      
      return res;
    } catch (error) {
      throw new Error('Error fetching mapped location list');
    }
  }
);


export const FetchMappedPatientList = createAsyncThunk(
  "MappedDataList/fetchMappedPatientList",
  async (params: any, { dispatch, getState }) => {
    try {
      const res: any = await getMappedPatientList(params);
      const state: any = getState();
      const previousMappedPatientList = state.MappedDataList?.MappedPatientList || []; // Extract the array correctly
      if ([1, undefined].includes(res?.result?.page)) {
        dispatch(setMappedPatientData(res?.result?.data || []));
      } else {


        dispatch(setMappedPatientData([
          ...previousMappedPatientList, // Keep existing data
          ...(res?.result?.data || []), // Append new data
        ]));
      }
      
      return res;
    } catch (error) {
      throw new Error('Error fetching mapped patient list');
    }
  }
);


export const UpdateLocationMapping = createAsyncThunk(
  "MappedDataList/UpdateLocationMapping",
  async ({id,params}: {id:any,params:any}, { dispatch, getState }) => {
    try {
      const res: any = await UpdateLocationMappingAPI(id,params);
      return res;
    } catch (error) {
      throw new Error('Error updating location mapping');
    }
  }
);



export const DeleteMappedLocation = createAsyncThunk(
  "MappedDataList/DeleteMappedLocation",
  async (ids: any, { rejectWithValue }) => {
    try {
      const res: any = await MappedLocationDeleteAPI({ ids });
      return res; // ✅ Fix: return the full response, not res.payload
    } catch (error: any) {
      return rejectWithValue({ success: false, message: "Delete failed" });
    }
  }
);



// Slice to manage MappedDataList state
const MappedDataListSlice = createSlice({
  name: 'MappedDataList',
  initialState,
  reducers: {
    setMappedLocationData(state, action: PayloadAction<any[]>) {
      state.MappedLocationList = action.payload;
    },
    setMappedPatientData(state, action: PayloadAction<any[]>) {
      state.MappedPatientList = action.payload;
    },
  }
});




export default MappedDataListSlice.reducer;
export const { setMappedLocationData,setMappedPatientData } = MappedDataListSlice.actions;
